import type { Team } from "~/context/AuthContext";
import type { PitchStatus, PitchTeam } from "~/types/PitchTypes";

export function pitchToTeam(
  pitch: PitchTeam,
  agencyId: number | null | undefined
): Team {
  return {
    id: pitch.id,
    domain: pitch.domain,
    country: pitch.country,
    brand_color: pitch.brand_color ?? undefined,
    brand_name: pitch.brand_name,
    creator_id: pitch.creator_id,
    agency_id: agencyId ?? null,
    has_brand_guidelines: pitch.has_brand_guidelines,
    is_pitch: pitch.is_pitch,
    pitch_status: pitch.pitch_status,
    role: pitch.role ?? null,
    created_at: pitch.created_at,
    updated_at: pitch.updated_at,
  };
}

const PITCH_HIDDEN_PATHS = [
  "/chats",
  "/library",
  "/keyword-clusters",
  "/settings",
  "/foundry",
  "/ai-visibility/signals",
  "/ai-visibility/ai-traffic-analytics",
];

export function isHiddenForPitch(pathname: string): boolean {
  return PITCH_HIDDEN_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

export const PITCH_STATUS_LABELS: Record<PitchStatus, string> = {
  draft: "Setting up",
  running: "Scanning",
  ready: "Ready",
  failed: "Needs a rerun",
  converted: "Client",
};
